module.exports = __webpack_public_path__ + "img/65.0af68ea0.jpg";